export default __webpack_public_path__ + "dfda03caf7096f2c1a28cfee89f37a27.png";